import { render, staticRenderFns } from "./assetsrequest.vue?vue&type=template&id=560eea0e"
import script from "./assetsrequest.vue?vue&type=script&lang=js"
export * from "./assetsrequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports